export default "__VITE_ASSET__CxJCq0ls__"